/*
 *
 * PayByLinkFilterModal
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 08-Apr-2025
*/

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PayByLinkFilterModal from './PayByLinkFilterModal'
import * as PayByLinkActions from '../../routes/PayByLink/modules/PayByLinkActions'
import { doHidePopup } from 'Store/actions/popup'
import { nullSafe } from 'Utility/globalMethods'

const mapDispatchToProps = dispatch => ({
  doHidePopup: () => dispatch(doHidePopup()),
  ...bindActionCreators(PayByLinkActions, dispatch)
})

const mapStateToProps = (state) => ({
  filters: nullSafe(() => state.popup.popupInfo.filters, {}),
  page: nullSafe(() => state.popup.popupInfo.page, 0),
  size: nullSafe(() => state.popup.popupInfo.size, 15),
  storeOptions: nullSafe(() => state.popup.popupInfo.storeOptions, [])
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(PayByLinkFilterModal)
